import { useMemo } from "react";

interface UseComparisonWidthsResult {
    baseDataWidth: number;
    compareDataWidth: number;
    noData: boolean;
}

export function useComparisonWidths(
    baseValue: number,
    compareValue: number,
    baseDate: string | undefined,
    compareDate: string | undefined
): UseComparisonWidthsResult {
    const baseDataWidth = useMemo(() => {
        if (!baseDate || !compareDate) {
            return 0;
        }

        if (baseDate === compareDate) {
            return 0;
        }

        if (baseValue === 0) {
            return 0;
        }

        if (compareValue === 0) {
            return 100;
        }

        if (baseValue < compareValue) {
            return (baseValue * 100) / compareValue;
        }

        return 100;
    }, [baseDate, compareDate, baseValue, compareValue]);

    const compareDataWidth = useMemo(() => {
        if (!baseDate || !compareDate) {
            return 0;
        }

        if (baseDate === compareDate) {
            return 0;
        }

        if (compareValue === 0) {
            return 0;
        }

        if (baseValue === 0) {
            return 100;
        }

        if (baseValue <= compareValue) {
            return 100;
        }

        return (compareValue * 100) / baseValue;
    }, [baseDate, compareDate, baseValue, compareValue]);

    const noData = baseDataWidth <= 0 && compareDataWidth <= 0;

    return { baseDataWidth, compareDataWidth, noData };
}
